import styled, { css } from 'styled-components'
import Draggable from 'react-draggable'
import colors from 'utils/styling/colors'
import zLayers from 'utils/styling/zLayers'
import { EDITOR_INACTIVE_BORDER_WIDTH } from '@messenger/consts'

export const Drag = styled(Draggable)``

export const ItemContainer = styled.div(
  ({ z, isWatermark, disabled }) => css`
    position: absolute;
    z-index: ${zLayers.getItemZ(z)};
    outline: ${isWatermark &&
    !disabled &&
    `${EDITOR_INACTIVE_BORDER_WIDTH}px solid`};
    outline-color: ${isWatermark && !disabled && colors('secondary')};
    pointer-events: ${disabled && 'none'};
    /* Prevent passive event listener warnings for draggable items */
    touch-action: ${disabled ? 'auto' : 'none'};
  `,
)

// This is for testing purposes on behalf of autosizing hook
export const WrapperHeightIndicator = styled.div(
  ({ width, height }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: ${width}px;
    height: ${height}px;
    border: 2px dashed #ff6b6b;
    background-color: rgba(255, 107, 107, 0.1);
    pointer-events: none;
    z-index: -1;
  `,
)
